import { render, staticRenderFns } from "./PictureStaticAsset.vue?vue&type=template&id=51f33638&scoped=true&"
import script from "./PictureStaticAsset.vue?vue&type=script&lang=js&"
export * from "./PictureStaticAsset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f33638",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/nicholashaskell/Local/kicknic/app/public/wp-content/themes/kicknic/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51f33638')) {
      api.createRecord('51f33638', component.options)
    } else {
      api.reload('51f33638', component.options)
    }
    module.hot.accept("./PictureStaticAsset.vue?vue&type=template&id=51f33638&scoped=true&", function () {
      api.rerender('51f33638', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/scripts/components/PictureStaticAsset.vue"
export default component.exports